import React, { Component } from 'react'
import _ from 'lodash'
import NavigationStore from '../stores/NavigationStore'

class BigBreadcrumbs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      items: props.items || [],
      icon: props.icon || 'fa fa-fw fa-home'
    }
  }

  componentDidMount() {
    // Always sync from NavigationStore so the icon from menu.json is used,
    // regardless of whether props.items was provided (each page passes it).
    if (NavigationStore.getData().item) {
      this._handleNavigationChange({ item: NavigationStore.getData().item })
    }
    this._navUnsub = NavigationStore.listen(data => this._handleNavigationChange(data))
  }

  componentWillUnmount() {
    if (this._navUnsub) this._navUnsub()
  }

  _handleNavigationChange(data) {
    const item = data.item
    if (item && item.route) {
      const { items, icon } = this._buildCrumbs(item)
      this.setState({ items, icon })
    }
  }

  _buildCrumbs(item) {
    const items = []
    let icon = ''
    const recurse = (current) => {
      items.unshift(current.pageTitle || current.title)
      if (!icon && current.icon) {
        icon = current.icon
        if (current.parent) {
          recurse(current.parent)
        }
      }
    }
    recurse(item)
    return { items, icon }
  }

  render() {
    const first = _.head(this.state.items)
    return (
      <div className={`${this.props.className} big-breadcrumbs`}>
        <h1 className="page-title txt-color-blueDark">
          <i className={this.state.icon} /> {first}
          {_.tail(this.state.items).map(item =>
            <span key={_.uniqueId('big-breadcrumb-')}>
              <span className="page-title-separator">&gt;</span>
              {item}
            </span>
          )}
        </h1>
      </div>
    )
  }
}

export default BigBreadcrumbs
